import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useModal } from '@jutro/components';
import { AddressComponent } from 'premier-capability-policyjob-react';
import { useTranslator } from '@jutro/locale';
import messages from './PropertyDetailsComponent.messages';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import metadata from './PropertyDetailsComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function PropertyDetailsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('PropertyDetailsComponent');
    const [isEditAddress, setIsEditAddress] = useState(false)
    const modelVM = _.get(submissionVM, pathUpdated);
    const { showConfirm } = useModal();
    const translator = useTranslator();

    modelVM.value.isValidationReq = true;


    const [actAddress, setActAddress] = useState(null)

    if (_.isUndefined(modelVM.accountLocFie.value)) {
        const model = { country: 'CA' }
        const { _xCenter, _dtoName } = modelVM.accountLocFie;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
    }

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            if (value === 'new' && changedPath === 'actLocPublicID') {
                setIsEditAddress(true)
            }

            if(changedPath === 'couFie') {
                const curFie1 = value === 'US' ? 'USD': 'CAD'

                _.set(modelVM.value, 'curFie1', curFie1)
            }

            if(changedPath === 'occFie' && value === 'Condominium') {
                _.set(modelVM.value, 'busUseFie', undefined)
            }

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [modelVM, pathUpdated, submissionVM, updateWizardData]
    );

    const onAddressChange = useCallback((value, changedPath) => {
        const fullPath = `${pathUpdated}.accountLocFie.${changedPath}`;

        _.set(submissionVM, `${fullPath}`, value);
        updateWizardData(submissionVM);
    }, [pathUpdated, submissionVM, updateWizardData]);


    const getAddressOptions = () => {
        const availableValues = submissionVM.value.baseData.account_Ext.accountLocations_Ext.map((actLct) => ({
            code: actLct.publicID,
            name: actLct.displayName
        }));

        return availableValues.concat({
            code: 'new',
            name: '-- Add New --'
        })
    };

    const setIsEditButton = () => {
        setActAddress(modelVM.accountLocFie.value)
        setIsEditAddress(true)
    }

    const setIsCancelButton = () => {
        const model = actAddress
        const { _xCenter, _dtoName } = modelVM.accountLocFie;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        setIsEditAddress(false)
    }

    const setIsSaveButton = () => {
        setIsEditAddress(false)
    }

    const getOccupancyAvailableValue = () => {
        if(submissionVM.baseData.baseState_Ext.value.code === 'QC') {
            return _.filter(modelVM.occFie.aspects.availableValues, (occFie) => !['Boathouse', 'Farm', 'Mobom'].includes(occFie.code)).map((occFie) => ({
                code: occFie.code,
                name: translator({
                    id: occFie.name,
                    defaultMessage: occFie.name
                })
            }))
        }

        return modelVM.occFie.aspects.availableValues.map((occFie) => ({
                code: occFie.code,
                name: translator({
                    id: occFie.name,
                    defaultMessage: occFie.name
                })
            }))
    }

    const fillAddressDetails = (value, changedPath) => {
        handleValueChange(value, changedPath)

        if (value === 'new') {
            const model = { country: 'CA', publicID: value }
            const { _xCenter, _dtoName } = modelVM.accountLocFie;
            const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

            _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        } else {

            modelVM.accountLocFie.value = _.find(submissionVM.value.baseData.account_Ext.accountLocations_Ext, (actLct) => actLct.publicID === value);
        }

        handleValueChange(modelVM.accountLocFie.value, 'accountLocFie')
    };

    const deletePropertyDetails = useCallback(
        () => {
            const infoListPath = 'lobData.perLine.coverables.perUmbLiaCoverable.propertyDetails.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        actLocPublicID: {
            availableValues: getAddressOptions(),
            onValueChange: fillAddressDetails
        },
        locRiskddressComponent: {
            labelPosition: 'left',
            value: modelVM.accountLocFie,
            viewModelService,
            readOnly: isEditAddress ? [] : ['addressLine1Field', 'addressLine2Field', 'addressLine3Field', 'addressCity', 'addressState', 'addressPostalCode'],
            hideFields: ['addressDescription', 'addressType', 'addressCountry', 'addressCounty'],
            requiredFields: ['addressLine1Field', 'postalCode'],
            onValueChange: onAddressChange
        },
        editAddressButton: {
            visible: modelVM.actLocPublicID.value !== 'new' && !isEditAddress
        },
        saveAddressButton: {
            visible: modelVM.actLocPublicID.value === 'new' || isEditAddress
        },
        cancelAddressButton: {
            visible: modelVM.actLocPublicID.value !== 'new' && isEditAddress
        },
        ifothexpFie: {
            visible: _.get(modelVM, 'occFie.value') === 'Other'
        },
        numOfArcFie: {
            visible: _.get(modelVM, 'proonAcrFie.value')
        },
        busUseFie: {
            visible: !_.isUndefined(_.get(modelVM, 'occFie.value'))
                && _.get(modelVM, 'occFie.value.code') !== 'Condominium',
            defaultValue: false
        },
        busIncFie: {
            visible: !_.isUndefined(_.get(modelVM, 'busUseFie.value'))
                && _.get(modelVM, 'busUseFie.value')
        },
        numofEmpFie: {
            visible: !_.isUndefined(_.get(modelVM, 'busUseFie.value'))
                && _.get(modelVM, 'busUseFie.value')
        },
        numofExoPetAniFie: {
            visible: _.get(modelVM, 'exoPetAniFie.value')
        },
        numofnonRenUniFie: {
            visible: _.get(modelVM, 'aretheanyrenunisuiFie.value') === false
        },
        shoTerRenFie: {
            visible: _.get(modelVM, 'aretheanyrenunisuiFie.value'),
            defaultValue: false
        },
        numofRenUniFie: {
            visible: _.get(modelVM, 'aretheanyrenunisuiFie.value')
        },
        renIncFie: {
            visible: _.get(modelVM, 'aretheanyrenunisuiFie.value')
        },
        manbyProManFie: {
            visible: _.get(modelVM, 'aretheanyrenunisuiFie.value')
        },
        occFie: {
            availableValues: getOccupancyAvailableValue()
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            setIsEditButton,
            setIsCancelButton,
            setIsSaveButton,
            deletePropertyDetails
        },
        resolveComponentMap: {
            AddressComponent
        },
        resolveClassNameMap: styles
    };


    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PropertyDetailsComponent.propTypes = wizardProps;
export default withRouter(PropertyDetailsComponent);
